module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: [_vm.e.theme]
  }, [(_vm.header) ? _c('header', [_c('e-title', {
    attrs: {
      "e": _vm.e,
      "extended": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('e-content', {
    attrs: {
      "text": _vm.text
    }
  }), _vm._v(" "), _c('footer', [(_vm.e.authors) ? [_c('h5', [_vm._v(_vm._s(_vm.e.authors.length == 0 ? 'Докладчик:' : 'Докладчики:'))]), _vm._v(" "), _c('e-authors', {
    attrs: {
      "authors": _vm.e.authors
    }
  })] : _vm._e(), _vm._v(" "), (_vm.e.attendees) ? [_c('h5', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("Придут:")]), _vm._v(" "), _c('e-attendees', {
    attrs: {
      "attendees": _vm.e.attendees
    }
  })] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e37d5f62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/extended.vue
// module id = 163
// module chunks = 1